import SecureStorage from "react-secure-storage";

class SessionManager {
  async getAccessToken() {
    try {
      const accessToken = (await SecureStorage.getItem(
        "access_token"
      )) as string;

      return accessToken;
    } catch (_e) {
      return undefined;
    }
  }

  async getRefreshToken() {
    try {
      const accessToken = (await SecureStorage.getItem(
        "refresh_token"
      )) as string;

      return accessToken;
    } catch (_e) {
      return undefined;
    }
  }

  async setAccessToken(token: any) {
    try {
      await SecureStorage.setItem("access_token", token);
      return true;
    } catch (_e) {
      return false;
    }
  }

  async setRefreshToken(token: string) {
    try {
      await SecureStorage.setItem("refresh_token", token);
      return true;
    } catch (_e) {
      return false;
    }
  }

  async getSessionToken() {
    try {
      const sessionToken = (await SecureStorage.getItem(
        "session_token"
      )) as string;

      return sessionToken;
    } catch (_e) {
      return undefined;
    }
  }

  async setSessionToken(token: string) {
    try {
      await SecureStorage.setItem("session_token", token);
      return true;
    } catch (_e) {
      return false;
    }
  }
}

export default SessionManager;
